export const MAP_LANDMARKS_LIST_GETTAGS = "MAP_LANDMARKS_LIST_GETTAGS";
export const MAP_LANDMARKS_LIST_GETTAGS_RESPONSE = "MAP_LANDMARKS_LIST_GETTAGS_RESPONSE";
export const MAP_LANDMARKS_LIST_GETTAGS_TOCREATE = "MAP_LANDMARKS_LIST_GETTAGS_TOCREATE";
export const MAP_LANDMARKS_LIST_GETTAGS_TOCREATE_RESPONSE = "MAP_LANDMARKS_LIST_GETTAGS_TOCREATE_RESPONSE";